<div class="e-close" (click)="close()">&times;</div>

<div class="e-content">
  <div class="e-section">
    <h3 i18n>Sichere Zahlung mit Käuferschutz</h3>
    <p i18n>
      Bezahlen Sie per Vorkasse oder mit den sicheren Zahlungsmethoden von Stripe.com. Wir unterstützen Zahlungsarten
      wie Kreditkarten, PayPal, Klarna, ApplePay, GooglePay, Alipay oder lokale Anbieter. Wir garantieren Ihre Zahlung
      sichere und geschützt.

      <br><br>Wir haben ein Käuferschutzprogramm entwickelt, um Ihnen zu garantieren, dass Ihre
      Transaktion mit uns sicher und geschützt ist. Jede Transaktion wird von strengen Sicherheitsmaßnahmen
      begleitet. Und falls doch mal etwas schief laufen sollte, erhalten Sie immer Ihr Geld zurück.
    </p>
  </div>

  <div class="e-section">
    <h3 i18n>Automatische Rechnung per Mail</h3>
    <p i18n>
      Nach dem Kauf erhalten Sie direkt alle relevanten Dokumente per E-Mail. Natürlich erhalten Sie auch eine
      Rechnung für den Kauf der Domain, die Sie sofort als Beleg in Ihre Buchhaltungssoftware hochladen können.
    </p>
  </div>

  <div class="e-section">
    <h3 i18n>Einfache Übertragung in Echtzeit</h3>
    <p i18n>
      Nach Kauf erhalten Sie in Echtzeit einen sogenannten AuthCode mit dem Sie direkt bei dem Provider Ihrer Wahl
      die Domain übernehmen und sich als Inhaber eintragen lassen können. Wenn Sie alle Schritte des Transfers sofort
      in die Wege leiten, ist die Domain innerhalb von Sekunden zu Ihrem eigenen Provider transferiert und Sie sind
      Inhaber der Domain.
    </p>
  </div>
</div>
